var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneCall = function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 16.261a12.133 12.133 0 0 1-6.453-6.468l3.4-3.406L4.887.122l-3.171 3.17A5.9 5.9 0 0 0 0 7.5C0 14.748 9.252 24 16.5 24a5.889 5.889 0 0 0 4.207-1.716l3.171-3.171-6.265-6.265Zm5.092 4.609A3.9 3.9 0 0 1 16.5 22C10.267 22 2 13.733 2 7.5a3.907 3.907 0 0 1 1.13-2.793L4.887 2.95l3.437 3.437-2.935 2.935.245.614a14.372 14.372 0 0 0 8.447 8.436l.606.231 2.926-2.927 3.437 3.437ZM14 2V0a10.011 10.011 0 0 1 10 10h-2a8.009 8.009 0 0 0-8-8Zm0 4V4a6.006 6.006 0 0 1 6 6h-2a4 4 0 0 0-4-4Z"
  })));
};
export default SvgPhoneCall;